import React from "react";
import styled from "styled-components";

import SentimentsModal from "../SentimentAnalysis/SentimentsModal";
const PanelContainer = styled.div`
  background-color: #fff;

  padding: 20px;

  border-radius: 3px;
  border: 1px solid rgba(23, 15, 48, 0.25);
  border-top: 0px;
  margin-top: 5px;
  min-height: calc(60vh + 100px);
`;

const Heading = styled.h2`
  color: #333;
  font-size: 1.5rem;
  margin-bottom: 10px;
`;

const Description = styled.p`
  color: #666;
  font-size: 1rem;
  line-height: 1.4;
`;

export const SentimentsPanel = ({ sentimentsData }) => (
  <PanelContainer>
    <Heading>Sentiments</Heading>
    {sentimentsData ? (
      <Description>
        <SentimentsModal modal={false} />
      </Description>
    ) : (
      <div>
        Meeting's sentiment analysis are not yet availabe, please try again in
        few minutes.
      </div>
    )}
  </PanelContainer>
);

// meetingName={this.props.meetingName}
// openTranscriptModal={this.openTranscriptAndScrollToTimestamp}
